import { word } from "@modules/core/utils/i18n"
import { ProgramBundleSubscriberEntity } from "@modules/programBundle/programBundleSubscribers/entities/programBundleSubscriberEntity"
import { ProgramSubscriberEntity } from "@modules/programs/programSubscriber/entities/programSubscriberEntity"
import { useProgramSubscriberActions } from "@modules/programs/programSubscriber/hooks/useProgramSubscriber"
import { useToast } from "@modules/ui/components/huToast"
import { useFormik } from "formik"
import * as Yup from "yup"

type InternalNoteFormikType = {
  internalNote: string
}

const validationSchema = Yup.object({
  internalNote: Yup.string().optional(),
})

export function useSubscriberInternalNoteFormik(
  programId: string,
  subscriberDetails: ProgramSubscriberEntity | ProgramBundleSubscriberEntity,
  moveToSubscriberDetails: () => void,
) {
  const { updateInternalNote, isUpdateInternalNote } = useProgramSubscriberActions(programId, subscriberDetails)
  const toast = useToast()

  const onSubmitForm = async () => {
    await updateInternalNote(formik.values.internalNote)
      .then(() => {
        toast.show({
          severity: "success",
          detail: word("program.subscribers.subscriptionDetails.internalNote.success"),
        })
        moveToSubscriberDetails()
      })
      .catch((error: any) => {
        toast.show({
          severity: "error",
          summary: word("global.error.label"),
          detail: error.message,
        })
      })
  }

  const formik = useFormik<InternalNoteFormikType>({
    enableReinitialize: true,
    initialValues: { internalNote: subscriberDetails.internalNote || "" },
    validationSchema,
    onSubmit: onSubmitForm,
  })

  return { formik, isSubmitting: isUpdateInternalNote }
}
